import { TEXT_AREA_LIMIT_MEDIUM_PLUS } from '@/constants';
import { AdvertDestination } from '@/types';
import { IsNotEmpty, IsUrl, MaxLength } from 'class-validator';

export class AdvertUrlSectionEditInput {
  @MaxLength(TEXT_AREA_LIMIT_MEDIUM_PLUS, {
    message: 'Please enter a shorter url',
  })
  @IsNotEmpty({ message: 'Please enter a url' })
  @IsUrl(
    {
      protocols: ['http', 'https', 'inspireapp'],
      require_tld: false,
    },
    {
      message: 'Please enter a valid url',
    }
  )
  advertUrl: string;

  advertDestination?: AdvertDestination;
}
